import {
  faAngleDown,
  faExclamationTriangle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";

function DeleteRecipientPopUp({ onConfirm, onCancel, recipientName }) {
  return (
    <div className="delete-recipient-popup">
      <div>
        <div className="danger-text-message mb-3">
          <FontAwesomeIcon icon={faExclamationTriangle} /> Delete recipient?
        </div>
        <div className="mb-2">Are you sure you want to delete recipient</div>
        <div>{recipientName}?</div>
      </div>
      <div className="ml-auto align-self-center">
        <Button
          className="marg-right-10"
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          className="w-100px marg-right-10"
          type="Submit"
        >
          Confirm
        </Button>
      </div>
    </div>
  );
}

export default DeleteRecipientPopUp;
